import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import { useAuth, formatApiErrorDetail } from "../lib/auth";

export default function ChangePasswordPage() {
  const { changePassword } = useAuth();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");
    if (newPw !== confirmPw) {
      setError("Nieuwe wachtwoorden komen niet overeen");
      return;
    }
    setSubmitting(true);
    try {
      await changePassword(oldPw, newPw);
      setSuccess("Wachtwoord bijgewerkt.");
      setOldPw(""); setNewPw(""); setConfirmPw("");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AppLayout title="Wachtwoord wijzigen">
      <div className="max-w-md neuro-card p-6">
        <form className="space-y-4" onSubmit={onSubmit} data-testid="change-password-form">
          <Field label="Huidig wachtwoord" type="password" value={oldPw} onChange={setOldPw} testid="old-password-input" />
          <Field label="Nieuw wachtwoord" type="password" value={newPw} onChange={setNewPw} testid="new-password-input" />
          <Field label="Bevestig nieuw wachtwoord" type="password" value={confirmPw} onChange={setConfirmPw} testid="confirm-password-input" />
          {error && <div data-testid="change-pw-error" className="text-sm text-[#E53935]">{error}</div>}
          {success && <div data-testid="change-pw-success" className="text-sm text-[#43A047]">{success}</div>}
          <button
            type="submit"
            disabled={submitting}
            data-testid="change-password-submit"
            className="w-full bg-zinc-900 text-white py-2.5 text-sm font-semibold tracking-wide uppercase rounded-sm hover:bg-[#1E88E5] transition-colors disabled:opacity-60"
          >
            {submitting ? "Bezig..." : "Wachtwoord wijzigen"}
          </button>
        </form>
      </div>
    </AppLayout>
  );
}

function Field({ label, type = "text", value, onChange, testid }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-zinc-500 block mb-1.5">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        data-testid={testid}
        className="w-full border border-zinc-300 focus:border-zinc-900 outline-none px-3 py-2.5 text-[15px] rounded-sm bg-white transition-colors"
      />
    </div>
  );
}
